export const countryList = [
    { label: "Brazil", value: "BR" },
    { label: "China", value: "CN" },
    { label: "India", value: "IN" },
    { label: "United Arab Emirates", value: "AE" },
    { label: "United Kingdom", value: "UK" },
    { label: "United States", value: "US" },
    { label: "Vietnam", value: "VN" }
];

export const PHONE_COUNTRY_CODES_LIST = [
    { value: "+55", label: "Brazil (+55)" },
    { value: "+86", label: "China (+86)" },
    { value: "+91", label: "India (+91)" },
    { value: "+65", label: "Singapore (+65)" },
    { value: "+971", label: "UAE (+971)" },
    { value: "+44", label: "United Kingdom (+44)" },
    { value: "+1", label: "United States (+1)" },
    { value: "+84", label: "Vietnam (+84)" }
];